<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <app-table-template
      tableTitle="Investments"
      [showTitle]="false"
      [showSearch]="true"
      [showPagination]="true"
      [showToggle]="false"
      [hasCardView]="true"
      [clickableRows]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="68"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (rowClicked)="rowClicked($event)">
      <app-entity-investment-card-container [currentPage]="currentPage()" (cardClicked)="rowClicked($event)"></app-entity-investment-card-container>
    </app-table-template>
  }

  @if (dataEmpty()) {
    <div class="empty">No investments available</div>
  }
</div>
